import { useState, useRef, useEffect, useContext, useCallback } from "react";
import { UserUIStateContext } from "../../../store/userUIStateContext";
import { OrgIdContext } from "../../../store/orgId_context";
import { DDD } from "../../../lib/ddd/ddd";
import StepsAndDocs from "../StepsAndDocs";

//const ddd =  DDD.WithConnectionKey(apiRequestAddress, "b22250e5-7a48-11ee-9108-ee67f6910206");
const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";


const Steps = ({invoiceId, onExecute:onExecuteI}) => {
    const { integrationDevice} = useContext(OrgIdContext);

    useEffect(() => {

    }, [invoiceId])

    const onExecute = (res) => {
        if(onExecuteI)
            onExecuteI(res);
    }

    return(
        <>
        <div>
            <StepsAndDocs invoiceId={invoiceId} onExecute={onExecute}/>
        </div>
        </>
    )

}

export default Steps;